import React, { Component } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import CashVL from './pages/RequestCVL/RequestCVL';
import './custom.css'

const queryClient = new QueryClient();

export default function App() {

    return (
        <QueryClientProvider client={queryClient}>
            <Layout>
                <Route exact path='/' component={Home} />
                <Route path='/RequestCVL' component={CashVL} />
            </Layout>
        </QueryClientProvider>
    );
}